import React from "react";
import usePitchScores from "../../hooks/usePitchScores";
import PitchScoreList from "../../components/List/PitchScore.list";

const CompanyPitchScores = (props) => {
  const { companyId, hasAccess = true } = props;

  const {
    data: pitchScores,
    loading: pitchScoresLoading,
    options: pitchScoresOptions,
    setOptions: setPitchScoresOptions,
    setFilters: setPitchScoresFilters,
  } = usePitchScores({
    failSilently: true,
    enabled: hasAccess,
  });

  React.useEffect(() => {
    if (hasAccess) {
      setPitchScoresFilters({
        companyId: [companyId],
        minPitchScore: 1,
      });
    }
  }, [companyId, hasAccess]);

  return (
    <PitchScoreList
      data={pitchScores?.results || []}
      total={pitchScores?.pageInfo?.totalResults || 0}
      loadingList={pitchScoresLoading}
      options={pitchScoresOptions}
      setOptions={setPitchScoresOptions}
      hasAccess={hasAccess}
    />
  );
};

export default CompanyPitchScores;
